const normalizeType = (value) => String(value ?? "").trim().toUpperCase();

// Build-time feature flag. Enabled by default; set the environment variable to
// "false" and rebuild the app to restore the original SIP sanctions behaviour.
export const IGNORE_SIP_ONLY_SANCTIONS =
  String(process.env.REACT_APP_IGNORE_SIP_ONLY_SANCTIONS ?? "true")
    .trim()
    .toLowerCase() === "true";

export const isSipOnlySanction = (match, type) => {
  if (!IGNORE_SIP_ONLY_SANCTIONS) return false;
  if (normalizeType(type) !== "SAN") return false;

  const descriptions = Array.isArray(match?.record?.descriptions)
    ? match.record.descriptions
    : [];

  return (
    descriptions.length > 0 &&
    descriptions.every(
      (description) => normalizeType(description?.recordType) === "SIP",
    )
  );
};

export const hasOnlySipSanctions = (results = []) => {
  const candidates = (Array.isArray(results) ? results : []).flatMap((match) =>
    (Array.isArray(match?.matchingCriteria) ? match.matchingCriteria : [])
      .map((criterion) => normalizeType(criterion?.searchType))
      .filter(Boolean)
      .map((type) => ({ match, type })),
  );

  return (
    candidates.length > 0 &&
    candidates.every(({ match, type }) => isSipOnlySanction(match, type))
  );
};
